/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PinIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABN0lEQVR4nOWTv07DMBDGPcAAE4xl5AVgAsFAHsC+P6mUnpMOLDQrGywIOsLDId4GpEpQZJqGKKojuyQTJ1mRHOn7fXe+T6nIApYSyN6pIUrr4hBJPpDtEkjmvQOY8zMnvj69Q3Sjg8EgyHLbBPQOAZJ5G1Cd5yHFl1EQw/mFW0dEmxLJpR4XxwHiYeNClscQIdwGYozZB5LPvwKwC9JHB1hDPIkPnTe2HP+scJ10+45sZ963iIFAYxxE1wcu8e7b+dihENg2ZIj2KATiVjhaXKeTEyBZIMtLBbn3AVxOosSTJNlBsq+/ItIJAZZxFKA9EiBZpOl0tOnfqoP8JlicqDhdjaZ29+bG1WHgC9GeB4mXZbnrBNeuke2Tu/OFsUr8Q7B7w3nic72psizbU7GFOLnyuVb/tr4Bh3yTaJf+8YoAAAAASUVORK5CYII=)
 */
export const PinIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M19.38 11.38a3 3 0 0 0 4.24 0l.03-.03a.5.5 0 0 0 0-.7L13.35.35a.5.5 0 0 0-.7 0l-.03.03a3 3 0 0 0 0 4.24L13 5l-2.92 2.92-3.65-.34a2 2 0 0 0-1.6.58l-.62.63a1 1 0 0 0 0 1.42l9.58 9.58a1 1 0 0 0 1.42 0l.63-.63a2 2 0 0 0 .58-1.6l-.34-3.64L19 11l.38.38ZM9.07 17.07a.5.5 0 0 1-.08.77l-5.15 3.43a.5.5 0 0 1-.63-.06l-.42-.42a.5.5 0 0 1-.06-.63L6.16 15a.5.5 0 0 1 .77-.08l2.14 2.14Z"
        className={colorClass}
      />
    </svg>
  );
};
